module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/point-1-7f424c982f843c0404284a53a4604d25.png";